import { Component, OnInit, Input } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppCoreService } from 'src/app/services/app-core.service';
import { MiscService } from 'src/app/services/misc/misc.service';
import { ConfigService } from 'src/app/services/system-config/configs/configs.service';

@Component({
    selector: 'app-vendor-config',
    templateUrl: './vendor-config-component.html',
    styleUrls: ['./vendor-config-component.scss']
})

export class VendorConfigComponent implements OnInit {
    vendorConfigForm: FormGroup;
    @Input() public vendorType: string;
    @Input() public vendorConfigId: number;

    isFormSubmitted = false;
    vendorConfigDetails: any[] = [];
    configData: any[] = [];
    useEnterKey: any;
    constructor(
        private appCoreService: AppCoreService,
        public activeModal: NgbActiveModal,
        private _fb: FormBuilder,
        private ngxLoaderService: NgxUiLoaderService,
        private miscService: MiscService,
        private configService: ConfigService,
        private titleService: Title
    ) {
        titleService.setTitle('Vendors');
     }

    ngOnInit() {
        this.vendorConfigForm = this._fb.group({
            configDetails: this._fb.array([])
        });
        this.bindMasterConfig();

        this.useEnterKey = !this.appCoreService.GetUserData().metaInfo.tabbasedtemplate;
    }

    get configDetails(): FormArray {
        return this.vendorConfigForm.get('configDetails') as FormArray;
    }

    bindMasterConfig() {
        this.miscService.GetMasterConfigs(this.vendorType).subscribe((res) => {
            if (res?.success) {
                this.vendorConfigDetails = res.data;
                this.updateVendorServiceConfigForm();
                this.bindConfig();
            }
        })
    }

    updateVendorServiceConfigForm() {
        const configDetailsArray = this.vendorConfigForm.get('configDetails') as FormArray;
        configDetailsArray.clear();
        this.vendorConfigDetails.forEach(item => {
            configDetailsArray.push(this._fb.group({
                title: [item.title],
                code: [item.code],
                ischecked: [false]
            }))
        })
    }

    bindConfig() {
        this.configService.GetAll().subscribe((res) => {
            if (res?.success) {
                this.configData = res?.data[0]?.vendorconfig ?? [];
                this.config();
            }
        });
    }

    config() {
        const configDetailsArray = this.vendorConfigForm.get('configDetails') as FormArray;
        const configDetailMap = new Map(this.vendorConfigDetails.map((configItem, index) => [configItem.code, index]));
        for (let key in this.configData) {
            const detailIndex = configDetailMap.get(key);
            if (detailIndex !== undefined) {
                const detailFormGroup = configDetailsArray.at(detailIndex) as FormGroup;
                detailFormGroup.patchValue({ ischecked: this.configData[key] });
            }
        }
    }

    onSaveClick() {
        try {
            if (this.vendorConfigForm.valid) {
                const formValues = this.vendorConfigForm.getRawValue();
                const vendorConfigData = formValues.configDetails.reduce((acc: any, item: any) => {
                    acc[item.code] = item.ischecked;
                    return acc;
                }, {});

                const requestObj = {
                    type: 'vendor',
                    configDetails: vendorConfigData
                };

                this.ngxLoaderService.start();
                this.configService.ManageConfigs(requestObj).subscribe((res) => {
                    if (res && res.success) {
                        this.activeModal.close('');
                        this.appCoreService.showMessage('Record Saved Successfully', 'Success', 'success');
                        this.ngxLoaderService.stop();
                    }
                })
            }
        } catch (err) {
            this.ngxLoaderService.stop();
        }
    }
}